import { UserRole } from '@/common/enums';
import { PLAY_PRODUCT } from './productsList';

export const COMPANY_USERS_LIST = [
  {
    id: 'u_ko2BK',
    createdAt: 1644256455431,
    updatedAt: 1644256455431,
    lastLogin: 1644256455431,
    companies: [
      {
        id: '123',
        name: 'Craftsman+',
        logo: '',
      },
    ],
    groups: [
      {
        id: 'g_ko2BK',
        name: 'Development',
      },
    ],
    licenses: [
      {
        id: PLAY_PRODUCT.id,
        totalUsers: 2,
        trial: false,
        seats: 2,
        durationLength: 30,
        durationType: 'months',
        startDate: 1644256455431,
        isEnabled: true,
        product: PLAY_PRODUCT,
        productId: PLAY_PRODUCT.id,
      },
    ],
    email: 'camilo.garcia@craftsmanplus.com',
    firstName: 'Camilo',
    lastName: 'Garcia',
    isEmailConfirmed: false,
    isEnabled: true,
    jobTitle: 'Fancy Pants',
    phone: '+97334795153',
    roles: [
      {
        id: 1,
        name: UserRole.SYSTEM_ADMIN,
      },
    ],
  },
  {
    id: 'u_ko2BK1',
    createdAt: 1644256455431,
    updatedAt: 1644256455431,
    lastLogin: 1649139600000,
    companies: [
      {
        id: '123',
        name: 'Craftsman+',
        logo: '',
      },
    ],
    groups: [
      {
        id: 'g_ko2BK',
        name: 'Development',
      },
    ],
    licenses: [
      {
        id: PLAY_PRODUCT.id,
        totalUsers: 2,
        trial: false,
        seats: 2,
        durationLength: 30,
        durationType: 'days',
        startDate: 1644256455431,
        isEnabled: false,
        product: PLAY_PRODUCT,
      },
    ],
    email: 'alan.parsons@craftsmanplus.com',
    firstName: 'Alan',
    lastName: 'Parsons',
    isEmailConfirmed: false,
    isEnabled: true,
    jobTitle: 'Fancy Pants',
    phone: '+97334795153',
    roles: [
      {
        id: 3,
        name: UserRole.AUTHOR,
      },
    ],
  },
  {
    id: 'u_ko2BK2',
    createdAt: 1644256455431,
    updatedAt: 1644256455431,
    lastLogin: 1650003655431,
    companies: [
      {
        id: '123',
        name: 'Craftsman+',
        logo: '',
      },
    ],
    groups: [
      {
        id: 'g_ko2BK1',
        name: 'Management',
      },
    ],
    licenses: [],
    email: 'richard.stephens@craftsmanplus.com',
    firstName: 'Richard',
    lastName: 'Stephens',
    isEmailConfirmed: false,
    isEnabled: true,
    jobTitle: 'Fancy Pants',
    phone: '+97334795153',
    roles: [
      {
        id: 2,
        name: UserRole.CRAFTSMAN_ADMIN,
      },
    ],
  },
  {
    id: 'u_ko2BK3',
    createdAt: 1644256455431,
    updatedAt: 1644256455431,
    lastLogin: 1644256455431,
    companies: [
      {
        id: '146',
        name: 'Test(noDuration)',
        logo: '',
      },
    ],
    groups: [],
    licenses: [],
    email: 'deleted.user@someemaildomain.com',
    firstName: 'User',
    lastName: 'Deleted',
    isEmailConfirmed: false,
    isEnabled: true,
    jobTitle: 'Fancy Pants',
    phone: '+97334795153',
    roles: [
      {
        id: 3,
        name: UserRole.AUTHOR,
      },
    ],
    permissions: [
      'creative:view',
      'creative:edit',
    ],
    deletedAt: new Date('2022/04/01'),
    deletedBy: [{
      createdAt: new Date('2022/04/01'),
      user: { email: 'camilo.garcia@craftsmanplus.com' },
    }],
  },
];

export default COMPANY_USERS_LIST;
